import { Pipe, PipeTransform } from '@angular/core';
import QRCode from "qrcode";

@Pipe({
  name: 'toQrCode'
})
export class ToQrCodePipe implements PipeTransform {
  private readonly scale = 3.75
  private readonly margin = 1
  transform(value: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const canvas = document.createElement('canvas');
      QRCode.toCanvas(canvas, value,{margin: this.margin, scale: this.scale}, (error) => {
        if (error) {
          reject(new Error('Failed to generate QR code: ' + error.message));
        } else {
          resolve(canvas.toDataURL());
        }
      });
    });
  }

}
